export default class LaptopNavigateEvent {
    constructor(type, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        this.type = type;
        this.screenType = screenType;
        this.screen = screen;
        this.autocenter = autoCenter;
        this.priority = priority;
        this.needsOverlay = needsOverlay;
        this.openUnderCurrent = openUnderCurrent;
        this.animationType = animationType;
        this.animationOptions = animationOptions;
    }
}

LaptopNavigateEvent.LAPTOP_SHOW_REQUEST = "LaptopNavigateEvent.LAPTOP_SHOW_REQUEST";
LaptopNavigateEvent.LAPTOP_HIDE_REQUEST = "LaptopNavigateEvent.LAPTOP_HIDE_REQUEST";

LaptopNavigateEvent.OPEN_SCREEN_REQUEST = "laptopOpenScreenRequest";
LaptopNavigateEvent.GOTO_SCREEN_REQUEST = "laptopGotoScreenRequest";
LaptopNavigateEvent.CLOSE_SCREEN_REQUEST = "laptopCloseScreenRequest";
LaptopNavigateEvent.CLOSE_ALL_SCREENS_REQUEST = "laptopCloseAllScreensRequest";
LaptopNavigateEvent.POP_UP_REQUEST = "laptopPopUpRequest";
LaptopNavigateEvent.CLOSE_POP_UP_REQUEST = "laptopClosePopUpRequest";